<template>
  <div>
    <div class="main">
      <h3>请完善信息，来获取最适合您的点子项目</h3>
      <img class="avatar" :src="headimage" alt="">
      <div class="content">
      <el-form label-position="left" label-width="80px" :model="openForm">
        <el-form-item label="性别">
          <!-- <el-radio-group v-model="openForm.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
          </el-radio-group> -->
          <div class="radio-wrap">
          <div class="radio-single">
            <el-radio v-model="openForm.sex" :label="1">男</el-radio>
          </div>
          <div class="radio-single right">
            <el-radio v-model="openForm.sex" :label="2">女</el-radio>
          </div> 
          </div>     
        </el-form-item>
        <el-form-item label="城市">
          <v-region @values="regionChange" :area="false"></v-region>
        </el-form-item>
        <el-form-item label="出生日期">
          <el-date-picker
            style="width: 100%"
            v-model="openForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择出生日期">
          </el-date-picker>
        </el-form-item>
        <div class="form-foot">
          <el-button type="primary" class="open-btn" @click="onOpen">确认</el-button>
        </div>
      </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie } from '../utils';

export default {
  data() {
    return {
      headimage: '',
      openForm: {
        sex: '',
        area: '',
        date: '',
        canOpen: false,
      }
    }
  },

  mounted() {
    this.headimage = getCookie('headimage');
  },

  methods: {
    async onOpen() {
      console.log(`--- sex = ${this.openForm.sex}`)
      console.log(this.openForm.area)
      console.log(this.openForm.date)
      if (this.openForm.sex != 1 && this.openForm.sex != 2) {
        this.$message.error(`请选择性别`)
        return;
      }
      if (!this.openForm.area || !this.openForm.area.province || !this.openForm.area.city) {
        this.$message.error(`请选择城市`)
        return;
      }
      if (!this.openForm.date) {
        this.$message.error(`请选择出生日期`)
        return;
      }

      // 城市
      let sex = this.openForm.sex;
      let city = this.openForm.area.city.key;
      let date = this.openForm.date.replace(/-/g, '')
      let unionId = getCookie('unionId');
      let data = {
        unionID: unionId,
        sex: sex,
        city: city,
        birthday: date
      }
      console.log(data)
      let res = await this.$axios.get(`https://home.51point.com/51point-0.0.1-SNAPSHOT/miniMdz/addGmoUser`, { params: data })
      console.log(res)
      if (res.data.isSuccess == 1) {
        this.$message.success('开通成功')
        this.$router.replace({ path: '/' })
        return;
      }else {
        this.$message.error('开通失败')
        return;
      }
    },

    regionChange(e) {
      console.log(e)
      this.openForm.area = e;
    }
  }
}
</script>

<style scoped>

.form-foot {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.open-btn {
  width: 240px;
}

h3 {
  text-align: center;
  margin-top: 30px;
  font-size: 16px;
  color: #65ae71;
  text-align: center;
  margin-bottom: 24px;
}

.avatar {
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  margin: 0 auto 10px;
}

.main {
  background: white;
  width: 60%;
  border-radius: 4px;
  margin: 10px auto;
}

.content {
  margin: 20px auto;
  /* width: 90%; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.radio-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}

.radio-single {
  height: 40px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right {
  border-left: 1px solid #DCDFE6;
}

>>> div.rg-select {
  margin-right: 0;
}

>>> div.rg-select div.rg-select__el div.rg-select__content {
  padding: 0px 30px 0px 15px;;
}

>>> .el-input__inner {
  box-sizing: border-box;
}

</style>